// extracted by mini-css-extract-plugin
export default {"root":"ThirdPartyAuthButtons__root__MSig2","horizontalLineSeparator":"ThirdPartyAuthButtons__horizontalLineSeparator__V55Lc"};